import $ from 'jquery';
import BaseSettings from './base-settings';
import {registerSettings} from "./register";

class CreditCardSettings extends BaseSettings {

}

registerSettings('ppcp_card', CreditCardSettings);